module.exports = __webpack_public_path__ + "img/little_girls_10.81b90810.jpg";